export const IdentityCardTypes = [
  "VotersIdentificationCard",
  "Passport",
  "DriversLicense",
  "GhanaCard",
] as const;
export type IdentityCardType = (typeof IdentityCardTypes)[number];
